/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Color_LimeInputs */

const en_booking_color_lime = /** @type {(inputs: Booking_Color_LimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lime`)
};

const pl_booking_color_lime = /** @type {(inputs: Booking_Color_LimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limonkowy`)
};

/**
* | output |
* | --- |
* | "Lime" |
*
* @param {Booking_Color_LimeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_color_lime = /** @type {((inputs?: Booking_Color_LimeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Color_LimeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_color_lime(inputs)
	return en_booking_color_lime(inputs)
});